let DISABLE = false;
DISABLE = true;
import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View, Animated } from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
import { Feather, FontAwesome } from "@expo/vector-icons";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";

import store from "app/redux/store";

export default class Target extends React.Component {
  static propTypes = {
    // chapterId: PropTypes.number,
    valueId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      id: textHelpers.randomString(),
      coords: null,
      bounds: null,
      hovered: false,
      draggingItem: null,
      prevDragging: {},
    };
  }

  async componentDidMount() {
    if (!DISABLE) this.subscribe();
    // this.unsubscribeFocus = RootNavigation.addListener("focus", () => {
    //   this.subscribe();
    // });
    // this.unsubscribeBlur = RootNavigation.addListener("blur", this.unsubscribe);
  }

  componentWillUnmount() {
    // this.unsubscribeFocus && this.unsubscribeFocus();
    // this.unsubscribeBlur && this.unsubscribeBlur();
    if (!DISABLE) this.unsubscribe();
  }

  unsubscribe = () => {
    this.unsubscribeRedux && this.unsubscribeRedux();
  };

  subscribe = async () => {
    let { chapterId, valueId, action, index } = this.props;
    if (!!this.unsubscribeRedux) return;
    this.unsubscribeRedux = store.subscribe(() => {
      // return;
      let { dragging } = store.getState();

      let { prevDragging } = this.state;
      // if (textHelpers.compareObjects(dragging, prevDragging)) {
      //   console.log("no change");
      //   return;
      // }

      // if (
      //   dragging.overlappingId == prevDragging.overlappingId &&
      //   dragging.overlappingChapterId == prevDragging.overlappingChapterId &&
      //   dragging.overlappingValueId == prevDragging.overlappingValueId &&
      //   dragging.overlappingIndex == prevDragging.overlappingIndex &&
      //   dragging.action == prevDragging.action
      // )
      //   return;
      // console.log(dragging);

      // console.log(dragging);
      if (dragging.layoutUpdatedAt != this.state.layoutUpdatedAt) {
        this.measure();
      }
      let hovered = dragging.overlappingId == this.state.id;
      if (hovered) {
        let setAction = false;
        console.log("HOVERED!!", index, chapterId, valueId, dragging);
        if (!!chapterId && dragging.overlappingChapterId != chapterId) {
          store.dispatch({
            type: "dragging/set_overlap_chapter_id",
            overlappingChapterId: chapterId,
          });
          setAction = true;
        } else if (!!valueId && dragging.overlappingValueId != valueId) {
          store.dispatch({
            type: "dragging/set_overlap_value_id",
            overlappingValueId: valueId,
          });
          setAction = true;
        } else if (index != undefined && dragging.overlappingIndex != index) {
          store.dispatch({
            type: "dragging/set_overlap_index",
            overlappingIndex: index,
          });
          setAction = true;
        }
        if (setAction) {
          store.dispatch({
            type: "dragging/set_action",
            action,
          });
        }
      } else if (!hovered) {
        // if (index !== undefined)
        //   console.log("NOT HOVERED!!", index, chapterId, valueId, dragging);
        let clearAction = false;
        if (index !== undefined) {
          // nothing
        } else if (!!chapterId && dragging.overlappingChapterId == chapterId) {
          if (action == dragging.action) {
            store.dispatch({
              type: "dragging/set_overlap_chapter_id",
              overlappingChapterId: null,
            });
            clearAction = true;
          }
        } else if (!!valueId && dragging.overlappingValueId == valueId) {
          if (action == dragging.action) {
            store.dispatch({
              type: "dragging/set_overlap_value_id",
              overlappingValueId: null,
            });
            clearAction = true;
          }
        }
        if (clearAction) {
          store.dispatch({
            type: "dragging/set_action",
            action: null,
          });
          store.dispatch({
            type: "dragging/set_action",
            overlappingIndex: null,
          });
        }
      }
      this.setState({
        layoutUpdatedAt: dragging.layoutUpdatedAt,
        // coords: dragging.coords,
        hovered,
        draggingItem: dragging.draggingItem,
        prevDragging: dragging,
      });
    });
  };

  measure = () => {
    if (DISABLE) return;
    if (this.ref) {
      this.ref.measure((x, y, width, height, pageX, pageY) => {
        // console.log(
        //   `x:${x}, y:${y}, w:${width}, h:${height}, px:${pageX}, py:${pageY}`
        // );
        let absX = pageX + width / 2;
        let absY = pageY + height / 2;
        // this.setState({absX, absY})
        this.setState({
          bounds: {
            x: pageX,
            y: pageY,
            width,
            height,
          },
        });
        let target = {
          // chapterId: chapter.id,
          // id: chapter.id,
          // moment_ids: items.map((i) => i.id),
          id: this.state.id,
          x,
          y,
          pageX,
          pageY,
          width,
          height,
        };
        store.dispatch({ type: "dragging/update_target", target });
      });
    }
  };

  render() {
    let { bounds, coords, hovered, draggingItem } = this.state;
    let { top, stealth } = this.props;

    return (
      <View style={styles.wrapper}>
        <View
          style={[styles.placeholder]}
          ref={(ref) => (this.ref = ref)}
          onLayout={({ nativeEvent }) => {
            this.measure();
          }}
        >
          <View
            style={[
              styles.background,
              top && { height: 3 },
              !!draggingItem && !stealth && styles.visible,
              hovered && styles.selected,
            ]}
          />
          {/*<Text>
            {hovered && "!!!"} {bounds?.x} {bounds?.y}
          </Text>*/}
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: "row",
    alignSelf: "stretch",
    height: 0,
    overflow: "visible",
    // borderWidth: 1,
  },
  placeholder: {
    // marginTop: sizes.base,
    flexDirection: "row",
    alignSelf: "stretch",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: sizes.itemHeight,
  },
  background: {
    ...StyleSheet.absoluteFillObject,
    bottom: undefined,
    height: sizes.itemHeight,
    backgroundColor: colors.trim,
    opacity: 0,
  },
  visible: {
    opacity: 0.2,
  },
  selected: {
    opacity: 0.5,
  },
});
